import { BedsContainer } from '../../containers/filters/BedsContainer';
import { EFilterType, IFilter } from '../../types/filters';

export const beds: IFilter = {
  component: BedsContainer,
  type: EFilterType.Openable,
};
